// src/reducers/attendanceReducer.js

import {
  RECORD_ATTENDANCE,
  FETCH_ATTENDANCE_RECORDS,
} from "../actions/constants";

const initialState = {
  attendanceRecords: [],
};

const attendance = (state = initialState, action) => {
  switch (action.type) {
    case RECORD_ATTENDANCE:
      return {
        ...state,
        attendanceRecords: [...state.attendanceRecords, action.payload],
      };
    case FETCH_ATTENDANCE_RECORDS:
      return { ...state, attendanceRecords: action.payload };
    default:
      return state;
  }
};

export default attendance;
